// removed by extract-text-webpack-plugin
module.exports = {"navbar-wrapper":"navbar-wrapper__2KlMa","navbar-logo":"navbar-logo__25hbp","navbar-brand-text":"navbar-brand-text__2wyTK","menu-item":"menu-item__3xh1r","beta":"beta__29ez9","navbar-transparent":"navbar-transparent__28y5p"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/coms/ConsoleNavbar/styles.scss
// module id = 2165
// module chunks = 1